import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-tail",
  "use": "icon-arrow-down-tail-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-tail\">\n<path d=\"M10.625 15.7425V3.28125C10.625 3.09875 10.5665 2.94896 10.4494 2.83188C10.3323 2.71479 10.1825 2.65625 10 2.65625C9.8175 2.65625 9.66771 2.71479 9.55062 2.83188C9.43354 2.94896 9.375 3.09875 9.375 3.28125V15.7425L4.82437 10.8988C4.69396 10.7683 4.54417 10.7031 4.375 10.7031C4.20583 10.7031 4.05937 10.7715 3.93562 10.9081C3.81187 11.0448 3.75 11.1977 3.75 11.3669C3.75 11.536 3.80854 11.6923 3.92563 11.8356L9.55062 17.8125C9.68104 17.9429 9.83083 18.0081 10 18.0081C10.1692 18.0081 10.319 17.9429 10.4494 17.8125L16.0744 11.8356C16.1915 11.6923 16.25 11.536 16.25 11.3669C16.25 11.1977 16.1881 11.0448 16.0644 10.9081C15.9406 10.7715 15.7942 10.7031 15.625 10.7031C15.4558 10.7031 15.306 10.7683 15.1756 10.8988L10.625 15.7425Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-down-tail.svg
// module id = grRB
// module chunks = 258